import React from 'react';
import { connect } from 'react-redux';

import PasswordForm from '../Blocks/PasswordForm';
import Logos from '../Blocks/Logos';

const resetPassword = (props) => {

	return (
		<div className='page'>

			<Logos xplink={props.user === null ? '/' : '/dashboard'} />

			<section className='page__section page__section--white'>

				<div className='wrapper wrapper--narrow clearfix'>

					<PasswordForm loggedIn={props.user === null ? false : true} />

				</div>

			</section>

		</div>
	);

}


const mapStateToProps = state => {
	return {
		user: state.user
	};
}

export default connect(mapStateToProps)(resetPassword);


// WEBPACK FOOTER //
// ./src/Pages/ResetPassword.js